// src/components/PostImage.js
//
// IG'nin GERÇEK feed fotoğraf davranışı (2025 spesifikasyonu):
// medya HER ZAMAN tam genişliktedir; kapsayıcının oranı medyanın KENDİ
// oranıdır, yalnız 1.91:1 (yatay sınır) .. 3:4 (dikey sınır, 1080×1440)
// aralığına sıkıştırılır. Aralık İÇİNDEKİ her fotoğraf bantsız ve
// kırpmasız tam görünür; aralık DIŞINDAKİLER (panorama / 9:16 ekran
// görüntüsü) IG'nin yükleme kırpmasının muadili olarak cover ile sınıra
// kırpılır. Yan bant asla oluşmaz.
//
// Oran önceliği: post doc'taki w/h (yeni yüklemeler NewPost'ta yazar —
// CLS yok) → yoksa naturalWidth/Height onLoad'da ölçülür.

import React, { useState, useCallback } from "react";

export const IG_MAX_RATIO = 4 / 3;     // 3:4 dikey sınır (h/w)
export const IG_MIN_RATIO = 1 / 1.91;  // 1.91:1 yatay sınır (h/w)

/**
 * `!= null` guard'ları EKLENDİ, davranış deltası YOK: `undefined > 0` ve
 * `null > 0` zaten `false` üretiyordu, sayıya çevrilebilen dizeler
 * (`"1080" > 0`) eskisi gibi geçiyor. Kontrol yalnız daraltmayı gösteriyor.
 */
export function clampRatio(w?: number | null, h?: number | null): number | null {
  if (!(w != null && w > 0) || !(h != null && h > 0)) return null;
  return Math.min(IG_MAX_RATIO, Math.max(IG_MIN_RATIO, h / w));
}

export type PostImageProps = {
  src?: string;
  alt?: string;
  className?: string;
  /** Post dökümanındaki ölçüler (yeni yüklemelerde var, eskilerde yok). */
  w?: number | null;
  h?: number | null;
  onLoad?: (e: React.SyntheticEvent<HTMLImageElement>) => void;
  onClick?: React.MouseEventHandler<HTMLImageElement>;
  eager?: boolean;
};

export default function PostImage({
  src,
  alt,
  className = "",
  w,
  h,
  onLoad,
  onClick,
  eager = false,
}: PostImageProps) {
  const declared = clampRatio(w, h);
  const [measured, setMeasured] = useState<number | null>(null);
  const ratio = declared || measured || 1; // ölçülene dek kare

  const handleLoad = useCallback((e: React.SyntheticEvent<HTMLImageElement>) => {
    // React'in `SyntheticEvent.target`i `EventTarget`; ölçüm alanları burada
    // daraltılıyor. `currentTarget`e GEÇMEK davranış değişikliği olurdu.
    const t = e?.target as HTMLImageElement | undefined;
    const r = clampRatio(t?.naturalWidth, t?.naturalHeight);
    if (r && !declared) setMeasured(r);
    onLoad?.(e);
  }, [declared, onLoad]);

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={{
        width: "100%",
        aspectRatio: `1 / ${ratio}`,
        objectFit: "cover",
        display: "block",
        background: "#fafafa",
      }}
      loading={eager ? "eager" : "lazy"}
      decoding="async"
      draggable="false"
      onLoad={handleLoad}
      onClick={onClick}
    />
  );
}
